// extracted by mini-css-extract-plugin
export default {"containerButton":"GroupsButtons_containerButton__mtVC+","circleVazio":"GroupsButtons_circleVazio__heECF","capa":"GroupsButtons_capa__Crhr4","title":"GroupsButtons_title__XifXP"};